import { ACT_EVT_CHANGE } from "./ActionTypes";
import RestaurantService from "../provider/restaurant/RestaurantService";
import {loading} from "./AppActions"
import MediaService from "../provider/media/MediaService";
import { sessionService } from 'redux-react-session';


export function actionSelectRestaurant(restaurant){
  return (dispatch, getStore) => {
    if(!getStore().ses.restaurant || restaurant.id!= getStore().ses.restaurant.id){
      sessionService.saveSession({...getStore().ses,restaurant:restaurant})
    }

      dispatch({
        type:ACT_EVT_CHANGE,
        props: {restaurant:restaurant}
    })
  }
}
/*** ACTIONS RESTAUTANTS ******/
export function actionGetRestaurants(successCallback, errorCallback) {
    return (dispatch, getStore) => {
        loading(true)(dispatch, getStore)
        RestaurantService.getRestaurants(getStore().app.app).then((response) => {
            dispatch({
                type:ACT_EVT_CHANGE,
                props: {restaurantList:response||[]}
            })
            successCallback&&successCallback()
        }).catch(errorCallback)
        .finally(()=>{loading(false)(dispatch, getStore)})
    };
}

export function actionSaveRestaurant(restaurantData, isCopyWithTickets, successCallback, errorCallback) {
    return (dispatch, getStore) => {
        loading(true)(dispatch, getStore)
        let restaurant = {...restaurantData, evtName:restaurantData.evtTitle}
        let uploadImg = restaurantData.evtImg && typeof restaurant.evtImg != 'string'
        let uploadLogo = restaurantData.resLogo && typeof restaurant.resLogo != 'string'

        if(!uploadImg&&!uploadLogo){//Si tiene una url y no un archivo seleccionado con el componente
          RestaurantService.saveRestaurant(getStore().app.app, restaurant, isCopyWithTickets, getStore().auth.email).then((response) => {
            successCallback()
          }).catch(errorCallback)
          .finally(()=>{loading(false)(dispatch, getStore)})
        }else{ //Si tiene un archivo seleccionado por el componente
          let p = []
          if(uploadImg){
            p.push(MediaService.uploadFile(restaurantData.evtImg.blob, 'restaurants', 'image'))  
          }
          if(uploadLogo){
            p.push(MediaService.uploadFile(restaurantData.resLogo.blob, 'restaurantsLogo', 'image'))
          }
          Promise.all(p).then(res => {
            if(uploadImg){
              if(restaurant.evtImgPath&&restaurant.evtImgPath!=res[0].path){
                MediaService.deleteFile(restaurant.evtImgPath)
              }
              restaurant.evtImg=res[0].downloadURL
              restaurant.evtImgName=res[0].filename
              restaurant.evtImgPath=res[0].path
            }
            if(uploadLogo){
              if(restaurant.resLogoPath&&restaurant.resLogoPath!=res[p.length-1].path){
                MediaService.deleteFile(restaurant.resLogoPath)
              }
              restaurant.resLogo=res[p.length-1].downloadURL
              restaurant.resLogoName=res[p.length-1].filename
              restaurant.resLogoPath=res[p.length-1].path
            }
            
            RestaurantService.saveRestaurant(getStore().app.app, restaurant, isCopyWithTickets, getStore().auth.email).then((response) => {
                successCallback()
            }).catch(errorCallback)
          }).catch(errorCallback)
          .finally(()=>{loading(false)(dispatch, getStore)})
        }
    };
}

export function actionDeleteRestaurant(restaurant, successCallback, errorCallback) {
  return (dispatch, getStore) => {
      loading(true)(dispatch, getStore)
      RestaurantService.deleteRestaurant(getStore().app.app, restaurant.id).then((response) => {
        restaurant.evtImgPath&&MediaService.deleteFile(restaurant.evtImgPath)  
        restaurant.resLogoPath&&MediaService.deleteFile(restaurant.resLogoPath)  
        successCallback()
      }).catch(errorCallback)
      .finally(()=>{loading(false)(dispatch, getStore)})
  };
}

export function actionQRLink(restaurant, tableFrom, tableTo, successCallback, errorCallback){
  return (dispatch, getStore) => {
    loading(true)(dispatch, getStore)
    if(tableTo){
      let qrsPromises = []
      for(let i=tableFrom;i<=tableTo;i++){
        qrsPromises.push(RestaurantService.getDynamicAppLink(restaurant.id, i))
      }
      Promise.all(qrsPromises).then((response)=>{
        successCallback&&successCallback(response)
      }).catch(errorCallback)
      .finally(()=>{loading(false)(dispatch, getStore)})
    }else{
      RestaurantService.getDynamicAppLink(restaurant.id, tableFrom)
      .then((response)=>{
        successCallback&&successCallback(response)
      }).catch(errorCallback)
      .finally(()=>{loading(false)(dispatch, getStore)})
    }
  }
}

/****** FIN ACTION RESTAURANT +**********/
/****** ACTION TICKET TYPES **********/
export function actionGetTicketTypes(successCallback, errorCallback) {
  return (dispatch, getStore) => {
      loading(true)(dispatch, getStore)
      RestaurantService.getTicketTypesByRestaurant(getStore().app.app, getStore().evt.restaurant.id).then((response) => {
          dispatch({
              type:ACT_EVT_CHANGE,
              props: {ticketTypeList:response}
          })
          successCallback&&successCallback()
      }).catch(errorCallback)
      .finally(()=>{loading(false)(dispatch, getStore)})
  };
}

export function actionSaveTicketType(ticketTypeData, successCallback, errorCallback) {
  return (dispatch, getStore) => {
    loading(true)(dispatch, getStore)
    let ticketType = ticketTypeData
    if(typeof ticketType.mnuImg == 'string'){//Si tiene una url y no un archivo seleccionado con el componente
      RestaurantService.saveTicketType(getStore().app.app, getStore().evt.restaurant.id, ticketType, getStore().auth.email).then((response) => {
        successCallback()
      }).catch(errorCallback)
      .finally(()=>{loading(false)(dispatch, getStore)})
    }else{ //Si tiene un archivo seleccionado por el componente
      MediaService.uploadFile(ticketTypeData.mnuImg.blob, 'menuItem', 'image').then(res => {
        if(ticketType.mnuImgPath&&ticketTypeData.mnuImgPath!=res.path){
          MediaService.deleteFile(ticketTypeData.mnuImgPath)
        }
        ticketType.mnuImg=res.downloadURL
        ticketType.mnuImgName=res.filename
        ticketType.mnuImgPath=res.path
        RestaurantService.saveTicketType(getStore().app.app, getStore().evt.restaurant.id, ticketType, getStore().auth.email).then((response) => {
          successCallback()
        }).catch(errorCallback)
      }).catch(errorCallback)
      .finally(()=>{loading(false)(dispatch, getStore)})
    }
  };
}

export function actionUpdateMenu(menuId, menu, successCallback, errorCallback) {
  return (dispatch, getStore) => {
    loading(true)(dispatch, getStore)
    RestaurantService.updateMenu(getStore().app.app, getStore().evt.restaurant.id, menuId, menu).then((response) => {
      successCallback&&successCallback()
    }).catch(errorCallback)
    .finally(()=>{loading(false)(dispatch, getStore)})
  }
}

export function actionDeleteTicketType(ticketTypeId, successCallback, errorCallback) {
  return (dispatch, getStore) => {
      RestaurantService.deleteTicketType(getStore().app.app,  getStore().evt.restaurant.id, ticketTypeId).then((response) => {
        successCallback()
      }).catch(errorCallback)
  };
}
/***** FIN ACTION TICKET TYPES *********/
/***** ACTION CATEGORIES *********/
export function actionGetCategories(successCallback, errorCallback) {
  return (dispatch, getStore) => {
      loading(true)(dispatch, getStore)
      RestaurantService.getMenuCategoriesByRestaurant(getStore().app.app, getStore().evt.restaurant.id).then((response) => {
          // console.log("CATEGORIES", response)
          dispatch({
              type:ACT_EVT_CHANGE,
              props: {categoryList:response}
          })
          successCallback&&successCallback()
      }).catch(errorCallback)
      .finally(()=>{loading(false)(dispatch, getStore)})
  };
}

export function actionSaveCategory(category, successCallback, errorCallback) {
  return (dispatch, getStore) => {
    loading(true)(dispatch, getStore)
    const restaurantId = getStore().evt.restaurant.id 
    if(!category.catImg || typeof category.catImg == 'string'){//Si tiene una url y no un archivo seleccionado con el componente
      let path = category.catImgPath
      if(category.catImgPath&&!category.catImg){
        delete category.catImg
        delete category.catImgPath
        delete category.catImgName
      }
      RestaurantService.saveMenuCategory(getStore().app.app, restaurantId, category).then((response) => {
        if(path){
          MediaService.deleteFile(path)
        }
        successCallback()
      }).catch(errorCallback)
      .finally(()=>{loading(false)(dispatch, getStore)})
    }else{ //Si tiene un archivo seleccionado por el componente
      MediaService.uploadFile(category.catImg.blob, 'menuCategories', 'image').then(res => {
        if(category.catImgPath&&category.catImgPath!=res.path){
          MediaService.deleteFile(category.catImgPath)
        }
        category.catImg=res.downloadURL
        category.catImgName=res.filename
        category.catImgPath=res.path
        RestaurantService.saveMenuCategory(getStore().app.app, restaurantId, category).then((response) => {
          successCallback()
        }).catch(errorCallback)
      }).catch(errorCallback)
      .finally(()=>{loading(false)(dispatch, getStore)})
    }
  };
}

export function actionDeleteCategory(category, successCallback, errorCallback) {
  return (dispatch, getStore) => {
      loading(true)(dispatch, getStore)
      RestaurantService.deleteMenuCategory(getStore().app.app,  getStore().evt.restaurant.id, category.id).then((response) => {
        MediaService.deleteFile(category.catImgPath)
        successCallback()
      }).catch(errorCallback)
      .finally(()=>{loading(false)(dispatch, getStore)})
  };
}
/***** FIN ACTION CATEGORIES *********/
/****** ACTION TICKETS **********/

export function registerOnChangeOrders(restaurant, callback){
  return RestaurantService.onChangeOrders(restaurant.id, callback)
}

export function actionGetTickets(restaurant, filter, successCallback, errorCallback) {
  return (dispatch, getStore) => {
      // loading(true)(dispatch, getStore)
      RestaurantService.getTicketsByRestaurant(getStore().app.app, restaurant.id, filter).then((response) => {
          dispatch({
              type:ACT_EVT_CHANGE,
              props: {ticketList:response, restaurant:restaurant}
          })
          successCallback&&successCallback()
      }).catch(errorCallback)
      // .finally(()=>{loading(false)(dispatch, getStore)})
  };
}

export function actionSendOrderToCook(order, successCallback, errorCallback){
  return (dispatch, getStore) => {
    // loading(true)(dispatch, getStore)
    RestaurantService.sendOrderToCook(getStore().app.app,  getStore().evt.restaurant.id, order).then((response) => {
      successCallback&&successCallback()
    }).catch(errorCallback)
    // .finally(()=>{loading(false)(dispatch, getStore)})
  }
}

export function actionReadyToDeliver(order, successCallback, errorCallback){
  return (dispatch, getStore) => {
    // loading(true)(dispatch, getStore)
    RestaurantService.readyToDeliver(getStore().app.app,  getStore().evt.restaurant.id, order).then((response) => {
      successCallback&&successCallback()
    }).catch(errorCallback)
    // .finally(()=>{loading(false)(dispatch, getStore)})
  }
}


export function actionDeliverOrder(order, successCallback, errorCallback){
  return (dispatch, getStore) => {
    // loading(true)(dispatch, getStore)
    RestaurantService.deliverOrder(getStore().app.app,  getStore().evt.restaurant.id, order).then((response) => {
      successCallback&&successCallback()
    }).catch(errorCallback)
    // .finally(()=>{loading(false)(dispatch, getStore)})
  }
}

export function actionSaveTickets(tickets, successCallback, errorCallback) {
  return (dispatch, getStore) => {
    loading(true)(dispatch, getStore)
    // let ticket = {
    //   // tktBuyDate:new Date().getTime(),
    //   tktBuyOperationId: 0,
    //   tktBuyerDU: ticketData.tktBuyerDU,
    //   tktCategory: ticketData.tktTicketType.tktCategory,
    //   tktColor: ticketData.tktTicketType.tktColor,
    //   tktDisplayName: ticketData.tktTicketType.tktDisplayName,
    //   tktIcon: ticketData.tktTicketType.tktIcon,
    //   tktIconFamily: ticketData.tktTicketType.tktIconFamily,
    //   tktOrigin:"standard",
    //   tktOwnerDU: ticketData.tktOwnerDU,
    //   tktOwnerLastName: ticketData.tktOwnerLastName,
    //   tktOwnerName: ticketData.tktOwnerName,
    //   tktOwnerName2: ticketData.tktOwnerName + " " + ticketData.tktOwnerLastName,
    //   tktPrice: ticketData.tktTicketType.tktPrice,
    //   tktPriceProducer: ticketData.tktTicketType.tktPriceProducer,
    //   tktRrpp: "",
    //   tktRrppComision: 0,
    //   tktState: "pendingUser",
    //   tktType: ticketData.tktTicketType.id
    // }
    const restaurantId = getStore().evt.restaurant.id 
    // const ticketTypeId = ticketType.id
    // const profileData = profileData
    const rrppId = "" 
    // const buyOperationId = 0
    const origin = "standard"
    RestaurantService.saveTickets(getStore().app.app, restaurantId, tickets, rrppId, origin).then((response) => {
      successCallback()
    }).catch(errorCallback)
    .finally(()=>{loading(false)(dispatch, getStore)})
  };
}

export function actionDeleteTicket(ticketId, du, successCallback, errorCallback) {
  return (dispatch, getStore) => {
      loading(true)(dispatch, getStore)
      RestaurantService.deleteTicket(getStore().app.app,  getStore().evt.restaurant.id, ticketId, du).then((response) => {
        successCallback()
      }).catch(errorCallback)
      .finally(()=>{loading(false)(dispatch, getStore)})
  };
}
/***** FIN ACTION TICKETS *********/
/*** ACTIONS STATISTICS ******/
export function actionStatisticsByRestaurant(restaurant, successCallback, errorCallback) {
  return (dispatch, getStore) => {
      loading(true)(dispatch,getStore)
      RestaurantService.getStatistics(getStore().app.app, restaurant.id).then((response) => {
          // console.log("STATISTICS", response)
          dispatch({
              type:ACT_EVT_CHANGE,
              props: {stats:response, restaurantStats:restaurant}
          })
          successCallback&&successCallback()
      }).catch(errorCallback)
      .finally(()=>{loading(false)(dispatch,getStore)})
  };
}

export function actionStatisticsRRPPByRestaurant(restaurantId, successCallback, errorCallback) {
  return (dispatch, getStore) => {
      loading(true)(dispatch, getStore)
      RestaurantService.getStatisticsRRPP(getStore().app.app, restaurantId).then((response) => {
          // console.log("STATISTICS RRPP", response)
          dispatch({
              type:ACT_EVT_CHANGE,
              props: {statsRRPPList:response}
          })
          successCallback&&successCallback()
      }).catch(errorCallback)
      .finally(()=>{loading(false)(dispatch, getStore)})
  };
}
/***** FIN ACTION STATISTICS *********/
/****** ACTION RESERVATIONS **********/

export function registerOnChangeReservations(restaurant, callback){
  return RestaurantService.onChangeReservations(restaurant.id, callback)
}

export function actionGetReservations(restaurant, filter, successCallback, errorCallback) {
  return (dispatch, getStore) => {
      // loading(true)(dispatch, getStore)
      RestaurantService.getReservations(getStore().app.app, restaurant.id, filter).then((response) => {
        console.log("ACTION GER RESERVATIONS", response)
          dispatch({
              type:ACT_EVT_CHANGE,
              props: {bookingList:response}
          })
          successCallback&&successCallback()
      }).catch(errorCallback)
      // .finally(()=>{loading(false)(dispatch, getStore)})
  };
}

export function actionSaveReservationState(booking, successCallback, errorCallback){
  return (dispatch, getStore) => {
    // loading(true)(dispatch, getStore)
    RestaurantService.saveReservationState(getStore().app.app,  getStore().evt.restaurant, booking).then((response) => {
      successCallback&&successCallback()
    }).catch(errorCallback)
    // .finally(()=>{loading(false)(dispatch, getStore)})
  }
}

/***** FIN ACTION RESERVATIONS *********/
/***** ACTION DDJJ *******/
export function registerOnChangeDDJJ(restaurantId, callback){
  return RestaurantService.onChangeDDJJ(restaurantId, callback)
}

export function actionGetDDJJByTable(filter, successCallback, errorCallback) {
  return (dispatch, getStore) => {
      loading(true)(dispatch, getStore)
      let restoId = getStore().auth.profile&&getStore().auth.profile.proRestoId
      RestaurantService.getDDJJByTable(getStore().app.app, restoId, filter).then((response) => {
          dispatch({
              type:ACT_EVT_CHANGE,
              props: {ddjjList:response}
          })
          successCallback&&successCallback(response)
      }).catch(errorCallback)
      .finally(()=>{loading(false)(dispatch, getStore)})
  };
}

export function actionGetDDJJHistory(filter, successCallback, errorCallback) {
  return (dispatch, getStore) => {
      loading(true)(dispatch, getStore)
      let restoId = getStore().auth.profile&&getStore().auth.profile.proRestoId
      RestaurantService.getDDJJ(getStore().app.app, restoId, filter).then((response) => {
        console.log("RESPONSE HISTORY", response)
          dispatch({
              type:ACT_EVT_CHANGE,
              props: {ddjjHistory:response}
          })
          successCallback&&successCallback(response)
      }).catch(errorCallback)
      .finally(()=>{loading(false)(dispatch, getStore)})
  };
}

export function actionControlDDJ(ddjj, errorCallback){
  return (dispatch, getStore) => {
    // loading(true)(dispatch, getStore)
    let restoId = getStore().auth.profile&&getStore().auth.profile.proRestoId
    RestaurantService.controlDDJJ(getStore().app.app, restoId, ddjj).catch(errorCallback)
    // .finally(()=>{loading(false)(dispatch, getStore)})
  }
}

/***** FIN ACTION DDJJ *****/


// WEBPACK FOOTER //
// ./src/actions/RestaurantActions.js